//@ts-nocheck
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchApplicationByDetails } from "../../../features/ApplicationData/ApplicationDataSlice";
import { useAppDispatch } from "../../../app/hooks";
import ReviewOverview from "../../jobApplicationDetails/candidateReview/ReviewOverview";
import ReviewResume from "../../jobApplicationDetails/candidateReview/ReviewResume";
import ReviewQuestionnaireSection from "../../jobApplicationDetails/candidateReview/ReviewQuestionnaireSection";

function ApplicationData({
  isOpenHeader,
  setIsOpenHeader,
  selectedFilterHeader,
  optionsWithAllStagesHeader,
  setSelectedFilterHeader,
  isConductReview,
  appreviewId,
  appreviewId1,
  QuestionsId,
  jobApplication,
  job,
}) {
  const { baseId, jobId, applicationId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();
  const dispatch = useAppDispatch();
  const [activeStatus, setActiveStatus] = useState<
    "Overview" | "Resume" | "Questionnaire"
  >("Overview");
  const [applicationDetails, setapplicationDetails] = useState("");

  useEffect(() => {
    if (applicationId || job) {
      const fetchJob = async () => {
        try {
          const res = await dispatch(
            fetchApplicationByDetails({
              baseId: Number(baseId),
              jobId: jobId,
              applicationId: applicationId || job,
            }),
          ).unwrap();
          if (res.status === 200) {
            setapplicationDetails(res?.data);
          }
        } catch (error) {
          console.error("Error fetching base member details:", error);
        }
      };
      fetchJob();
    }
  }, [applicationId, dispatch, job, jobId, baseId]);

  // Tab click handlers
  const handleStatusDraft = () => {
    setActiveStatus("Overview");
    // navigate(`/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`, { replace: true });
  };

  const handleStatusPending = () => {
    setActiveStatus("Resume");
    // navigate(`/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`, { replace: true });
  };

  const handleStatusCompleted = () => {
    setActiveStatus("Questionnaire");
  };

  return (
    <div>
      <div className="">
        <div className="w-full">
          <div className="flex items-center justify-center ml-[0px] pt-2 pb-4 px-4">
            <button
              className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px]
               border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tl-md rounded-bl-md ${activeStatus === "Overview" ? "bg-[#6b7280] text-white  border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
              onClick={handleStatusDraft}
            >
              Overview
            </button>
            <button
              className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${activeStatus === "Resume" ? "bg-[#6b7280] text-white border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
              onClick={handleStatusPending}
            >
              Resume
            </button>
            <button
              className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] border
               border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md ${activeStatus === "Questionnaire" ? "bg-[#6b7280] text-white border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
              onClick={handleStatusCompleted}
            >
              Questionnaire
            </button>
          </div>
          <div className="flex-grow">
            {activeStatus === "Overview" && (
              <div className="w-full h-full">
                <ReviewOverview
                  applicationDetails={applicationDetails}
                  setapplicationDetails={setapplicationDetails}
                  isConductReview={isConductReview}
                />
              </div>
            )}
            {activeStatus === "Resume" && (
              <div className="w-full h-full pt-2 pb-8">
                <ReviewResume
                  resumeData={applicationDetails?.application?.app_resume}
                />
              </div>
            )}

            {activeStatus === "Questionnaire" && (
              <div className="w-full h-full pt-2 pb-8">
                <ReviewQuestionnaireSection
                  appreviewId={appreviewId}
                  app={applicationId || applicationDetails?.application?.id}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApplicationData;
